// extracted by mini-css-extract-plugin
module.exports = {"signUp":"App_signUp__8yHuJ","body":"App_body__2a4FT"};